/**
 * QCS development tooling gate.
 * Enabled in local dev by default; set REACT_APP_QCS_DEV=0 to disable.
 */
export const QCS_DEV_ENABLED =
  process.env.REACT_APP_QCS_DEV === '1' ||
  Boolean(process.env.REACT_APP_QCS_DEV_IDS) ||
  (process.env.NODE_ENV === 'development' && process.env.REACT_APP_QCS_DEV !== '0')
